import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Vận tải (Ezy › TMS). Mã nghiệp vụ, biển số, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'tms.noCustomer': 'Chưa gắn khách',
  'tms.address': 'Địa chỉ',
  'tms.ward': 'Phường / xã',
  'tms.unverified': 'chưa xác thực',
  'tms.kindRoute': 'Tuyến',
  'tms.kindToll': 'Trạm thu phí',
  'tms.approveRoute': 'Duyệt tuyến',
  'tms.priceTrf': 'Tính giá TRF',
  'tms.noToll': 'Chưa gắn trạm',
  'tms.lowConfWarn': 'Toạ độ tin cậy thấp · kiểm lại trước khi tính phí tuyến',
  'tms.noRouteForToll': 'Chưa có tuyến gắn trạm này',
  'tms.lowConf': 'tin cậy thấp',
  'tms.rp.runKm': 'Km chạy',
  'tms.rp.tierKm': 'Km tra bậc',
  'tms.rp.fuel': 'Dầu',
  'tms.rp.loadEmpty': 'Tải / rỗng',
  'tms.rp.vetcStations': 'Trạm VETC',
  'tms.handle': 'Tôi xử lý',
  'tms.filter': 'Lọc',
  'tms.mapLabel': 'Cát Lái · KCN Sóng Thần · ICD Phước Long',
  'tms.assign': 'Gán xe',
  'tms.dutyThanh': 'Đang trực: THANH · tới 17:30',
  'tms.createTrip': 'Tạo chuyến',
  'tms.lateVsPlan': 'Trễ so giờ hẹn',
  'tms.confirm': 'Xác nhận',
  'tms.costTrucking': 'Chi phí theo mảng Trucking',
  'tms.pending': 'Lệnh chờ gán',
  'tms.pendingHint': 'chọn rồi bấm tên xe trên lưới',
  'tms.pick': 'Chọn',
  'tms.today': 'Hôm nay',
  'tms.tomorrow': 'Ngày mai',
  'tms.onDuty': 'Đang trực: PhongNT',
  'tms.exceptions': 'Ngoại lệ · 5',
  'tms.ask': 'Hỏi Ask HANA',
  'tms.dutyNow': 'ĐANG TRỰC',
  'tms.dutyAdmin': 'Hành chính · tới 17:30',
  'tms.dutyNext': 'Kế tiếp: sáng sớm 06:00–08:00 thứ Sáu 23/Oct',
  'tms.otOct': 'OT tháng 10',
  'tms.swapShift': 'Xin đổi ca với PHONG',
  'tms.cutTrailer': 'Cắt mooc',
  'tms.swapTruck': 'Đổi xe',
  'tms.reeferPower': 'Cont lạnh mất điện',
  'tms.reeferDetail': 'TR-2610-0315 · 51C-903.55 · Trần Văn Hải · −18 → −14 °C. 15′ sẽ gọi PHONG.',
  'tms.callDriver': 'Gọi tài xế',
  'tms.iHandle': 'Tôi xử lý',
  'tms.viewOnlyAssign': 'Chỉ xem: không có quyền gán xe hay đổi chuyến.',
  'tms.clearFilter': 'Bỏ lọc',
  'tms.densityStd': 'Chuẩn',
  'tms.densityCompact': 'Gọn',
  'tms.viewOnly': 'Chỉ xem.',
  'tms.noRouteMatch': 'Không có tuyến khớp lọc',
  'tms.awaitApproval': 'chờ duyệt',
  'tms.noGps': 'thiếu GPS',
  'tms.priceExpiring': 'sắp hết hạn giá',
  'tms.addRoute': 'Thêm tuyến',
  'tms.fleetOverview': 'Tổng quan xe',
  'tms.activeVehicles': 'Xe hoạt động',
  'tms.tractors': 'đầu kéo',
  'tms.alerts': 'Cảnh báo · 5',
  'tms.vehicleList': 'Danh sách xe & mooc',
  'tms.fleetFoot': 'Điều xe PhongNT · GPS cập nhật 1 phút (adsun-proxy)',
  'tms.mapVehicles': 'Xe trên bản đồ · VietMap',
  'tms.catLai': 'Cát Lái',
  'tms.trungLuong': 'Trung Lương',
  'tms.vinhLong': 'Vĩnh Long',
  'tms.addVehicle': 'Thêm xe',
  'tms.placesMap': 'Bản đồ điểm & tuyến ›',
  'tms.edit': 'Sửa',
  'tms.copyCoords': 'Sao toạ độ',
  'tms.noCarrier': 'Chưa ghi hãng nào',
  'tms.coords': 'Toạ độ',
  'tms.area': 'Khu vực',
  'tms.province': 'Tỉnh',
  'tms.hours': 'Giờ hoạt động',
  'tms.ecus': 'Mã ECUS',
  'tms.open': 'Mở',
  'tms.noPlaceMatch': 'Không có điểm khớp lọc',
  'tms.addPlace': 'Thêm điểm',
  'tms.addToll': 'Thêm trạm',
  'tms.viewOnlyShort': 'Chỉ xem',
  'tms.ov.volume': 'Sản lượng chuyến · 14 ngày',
  'tms.ov.perDay': 'chuyến/ngày',
  'tms.ov.outside': 'nhà xe ngoài',
  'tms.ov.byProgress': 'Chuyến hôm nay theo tiến độ',
  'tms.ov.trips': 'chuyến',
  'tms.ov.onTime': 'Đúng giờ hôm nay',
  'tms.ov.todayTrips': 'Chuyến hôm nay · 22/Oct/2026',
  'tms.ov.thVehicle': 'Xe · tài xế',
  'tms.ov.thTrip': 'Chuyến · job',
  'tms.ov.thGps': 'Tiến độ GPS (7 bước)',
  'tms.ov.thDue': 'Hạn',
  'tms.ov.map': 'Bản đồ',
  'tms.ov.mapNote': 'VietMap · cập nhật 1 phút',
  'tms.ov.unassigned': 'Chưa gán xe',
  'tms.ov.notOpen': 'Mục này chưa mở',
  'tms.ov.noTripsToday': 'Chưa có chuyến hôm nay',
  'tms.ov.retry': 'Thử lại',
  'tms.ov.urgent': 'gấp',
  'tms.td.ownTruck': 'xe nhà',
  'tms.td.sameTruck': 'Cùng xe',
  'tms.td.finish': 'Finish lệnh',
  'tms.td.plan': 'Kế hoạch chuyến',
  'tms.td.stops': 'điểm',
  'tms.td.remind': 'Nhắc tài xế',
  'tms.td.runTime': 'Thời gian chạy',
  'tms.td.trackGps': 'Theo dõi GPS',
  'tms.td.mergeStop': 'Ghép điểm',
  'tms.td.earlyDrop': 'Xin hạ sớm / closing',
  'tms.td.idx': 'Chỉ số vận hành',
  'tms.td.calcOnFinish': 'tính khi Finish',
  'tms.td.logLeg': 'Ghi chặng',
  'tms.td.confirmAll': 'Xác nhận tất cả',
  'tms.td.thEvent': 'Sự kiện',
  'tms.td.thSource': 'Nguồn',
  'tms.td.phasePhotos': 'Ảnh theo pha',
  'tms.td.photo': 'Ảnh',
  'tms.td.movePhase': 'Chuyển pha',
  'tms.td.sendAll': 'Gửi tất cả cho tài xế',
  'tms.td.exportCsv': 'Xuất CSV',
  'tms.td.askJob': 'Hỏi nhóm job',
  'tms.td.needConfirm': 'cần xác nhận',
  'tms.td.depotLimit': 'Hạn chế kho',
  'tms.td.call': 'Gọi',
  'tms.td.back': 'Về điều độ',
  'tms.rp.viewAs': 'Xem như',
  'tms.rp.save': 'Lưu giá',
  'tms.rp.inputs': 'Đầu vào',
  'tms.rp.cargo': 'Loại hàng',
  'tms.rp.shape': 'Kiểu tuyến',
  'tms.rp.addStop': 'Thêm điểm giao',
  'tms.rp.km': 'Km tuyến',
  'tms.rp.kmBad': 'Nhập số km > 0',
  'tms.rp.empty': 'Tỉ lệ rỗng',
  'tms.rp.thStation': 'Trạm',
  'tms.rp.vetcTot': 'Tổng VETC',
  'tms.rp.table': 'Bảng tra đang áp',
  'tms.rp.result': 'Kết quả',
  'tms.rp.explain': 'Giải thích giá',
  'tms.rp.totalCost': 'Tổng chi phí',
  'tms.rp.extraStop': 'Điểm chen',
  'tms.rp.noMoney': 'Không có quyền xem tiền.',
  'tms.rp.noTrf': 'Không có quyền xem giá TRF.',
  'tms.rp.pickRoute': 'Chọn tuyến',
  'tms.rp.close': 'Đóng',
  'tms.rp.ticketL5': 'Vé lượt L5',
  'tms.rp.amount': 'Thành tiền',
  'tms.rp.vetcTariff': 'Biểu phí VETC 10/2026',
});

addMessages('en', {
  'tms.noCustomer': 'No customer linked',
  'tms.address': 'Address',
  'tms.ward': 'Ward',
  'tms.unverified': 'unverified',
  'tms.kindRoute': 'Routes',
  'tms.kindToll': 'Toll stations',
  'tms.approveRoute': 'Approve route',
  'tms.priceTrf': 'Price TRF',
  'tms.noToll': 'No toll station linked',
  'tms.lowConfWarn': 'Low-confidence coordinates · recheck before pricing the route',
  'tms.noRouteForToll': 'No route linked to this station',
  'tms.lowConf': 'low confidence',
  'tms.rp.runKm': 'Run km',
  'tms.rp.tierKm': 'Tier km',
  'tms.rp.fuel': 'Fuel',
  'tms.rp.loadEmpty': 'Loaded / empty',
  'tms.rp.vetcStations': 'VETC stations',
  'tms.handle': 'I\'ll handle it',
  'tms.filter': 'Filter',
  'tms.mapLabel': 'Cát Lái · Sóng Thần IP · Phước Long ICD',
  'tms.assign': 'Assign vehicle',
  'tms.dutyThanh': 'On duty: THANH · until 17:30',
  'tms.createTrip': 'Create trip',
  'tms.lateVsPlan': 'Late vs. scheduled time',
  'tms.confirm': 'Confirm',
  'tms.costTrucking': 'Costs by Trucking segment',
  'tms.pending': 'Orders awaiting assignment',
  'tms.pendingHint': 'pick one, then tap a vehicle on the grid',
  'tms.pick': 'Pick',
  'tms.today': 'Today',
  'tms.tomorrow': 'Tomorrow',
  'tms.onDuty': 'On duty: PhongNT',
  'tms.exceptions': 'Exceptions · 5',
  'tms.ask': 'Ask HANA',
  'tms.dutyNow': 'ON DUTY',
  'tms.dutyAdmin': 'Office hours · until 17:30',
  'tms.dutyNext': 'Next: early shift 06:00–08:00 Friday 23/Oct',
  'tms.otOct': 'OT for October',
  'tms.swapShift': 'Request a shift swap with PHONG',
  'tms.cutTrailer': 'Cut trailer',
  'tms.swapTruck': 'Swap vehicle',
  'tms.reeferPower': 'Reefer container lost power',
  'tms.reeferDetail': 'TR-2610-0315 · 51C-903.55 · Trần Văn Hải · −18 → −14 °C. PHONG will be called in 15′.',
  'tms.callDriver': 'Call driver',
  'tms.iHandle': 'I\'ll handle it',
  'tms.viewOnlyAssign': 'View only: no permission to assign vehicles or change trips.',
  'tms.clearFilter': 'Clear filters',
  'tms.densityStd': 'Standard',
  'tms.densityCompact': 'Compact',
  'tms.viewOnly': 'View only.',
  'tms.noRouteMatch': 'No routes match the filter',
  'tms.awaitApproval': 'pending approval',
  'tms.noGps': 'missing GPS',
  'tms.priceExpiring': 'price expiring',
  'tms.addRoute': 'Add route',
  'tms.fleetOverview': 'Fleet overview',
  'tms.activeVehicles': 'Active vehicles',
  'tms.tractors': 'tractors',
  'tms.alerts': 'Alerts · 5',
  'tms.vehicleList': 'Vehicles & trailers',
  'tms.fleetFoot': 'Dispatch PhongNT · GPS refreshes every 1 min (adsun-proxy)',
  'tms.mapVehicles': 'Vehicles on map · VietMap',
  'tms.catLai': 'Cát Lái',
  'tms.trungLuong': 'Trung Lương',
  'tms.vinhLong': 'Vĩnh Long',
  'tms.addVehicle': 'Add vehicle',
  'tms.placesMap': 'Places & routes map ›',
  'tms.edit': 'Edit',
  'tms.copyCoords': 'Copy coordinates',
  'tms.noCarrier': 'No carrier recorded',
  'tms.coords': 'Coordinates',
  'tms.area': 'Area',
  'tms.province': 'Province',
  'tms.hours': 'Operating hours',
  'tms.ecus': 'ECUS code',
  'tms.open': 'Open',
  'tms.noPlaceMatch': 'No places match the filter',
  'tms.addPlace': 'Add place',
  'tms.addToll': 'Add toll station',
  'tms.viewOnlyShort': 'View only',
  'tms.ov.volume': 'Trips volume · 14 days',
  'tms.ov.perDay': 'trips/day',
  'tms.ov.outside': 'outside carriers',
  'tms.ov.byProgress': "Today's trips by progress",
  'tms.ov.trips': 'trips',
  'tms.ov.onTime': 'On time today',
  'tms.ov.todayTrips': "Today's trips · 22/Oct/2026",
  'tms.ov.thVehicle': 'Vehicle · driver',
  'tms.ov.thTrip': 'Trip · job',
  'tms.ov.thGps': 'GPS progress (7 steps)',
  'tms.ov.thDue': 'Due',
  'tms.ov.map': 'Map',
  'tms.ov.mapNote': 'VietMap · updated 1 min ago',
  'tms.ov.unassigned': 'Unassigned',
  'tms.ov.notOpen': 'This section is not open yet',
  'tms.ov.noTripsToday': 'No trips today',
  'tms.ov.retry': 'Retry',
  'tms.ov.urgent': 'urgent',
  'tms.td.ownTruck': 'own truck',
  'tms.td.sameTruck': 'Same truck',
  'tms.td.finish': 'Finish order',
  'tms.td.plan': 'Trip plan',
  'tms.td.stops': 'stops',
  'tms.td.remind': 'Remind driver',
  'tms.td.runTime': 'Run time',
  'tms.td.trackGps': 'Track GPS',
  'tms.td.mergeStop': 'Merge stop',
  'tms.td.earlyDrop': 'Request early drop / closing',
  'tms.td.idx': 'Operating metrics',
  'tms.td.calcOnFinish': 'computed on Finish',
  'tms.td.logLeg': 'Log leg',
  'tms.td.confirmAll': 'Confirm all',
  'tms.td.thEvent': 'Event',
  'tms.td.thSource': 'Source',
  'tms.td.phasePhotos': 'Photos by phase',
  'tms.td.photo': 'Photo',
  'tms.td.movePhase': 'Move phase',
  'tms.td.sendAll': 'Send all to driver',
  'tms.td.exportCsv': 'Export CSV',
  'tms.td.askJob': 'Ask job group',
  'tms.td.needConfirm': 'needs confirmation',
  'tms.td.depotLimit': 'Depot restrictions',
  'tms.td.call': 'Call',
  'tms.td.back': 'Back to dispatch',
  'tms.rp.viewAs': 'View as',
  'tms.rp.save': 'Save price',
  'tms.rp.inputs': 'Inputs',
  'tms.rp.cargo': 'Cargo type',
  'tms.rp.shape': 'Route type',
  'tms.rp.addStop': 'Add drop-off',
  'tms.rp.km': 'Route km',
  'tms.rp.kmBad': 'Enter km > 0',
  'tms.rp.empty': 'Empty ratio',
  'tms.rp.thStation': 'Station',
  'tms.rp.vetcTot': 'VETC total',
  'tms.rp.table': 'Active lookup table',
  'tms.rp.result': 'Result',
  'tms.rp.explain': 'Explain price',
  'tms.rp.totalCost': 'Total cost',
  'tms.rp.extraStop': 'Extra stop',
  'tms.rp.noMoney': "You don't have permission to view money.",
  'tms.rp.noTrf': "You don't have permission to view TRF prices.",
  'tms.rp.pickRoute': 'Pick a route',
  'tms.rp.close': 'Close',
  'tms.rp.ticketL5': 'Single-trip ticket L5',
  'tms.rp.amount': 'Amount',
  'tms.rp.vetcTariff': 'VETC tariff 10/2026',
});
